import * as React from 'react';

import { trackClickOffer, trackClickOfferPhone } from './tracking';
import { PublicationDate } from '../../../components/OfferCard/PublicationDate';
import { useOfferContext } from '../../../context';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getCianDomain } from '../../../utils/cianDomain';
import { getAddress } from '../../../utils/offers';
import { ControlsContainer } from '../Controls/ControlsContainer';
import { OfferAgentContainer } from '../OfferAgent';
import { OfferAreaContainer } from '../OfferArea';
import { OfferGeoContainer } from '../OfferGeo';
import { OfferNoteContainer } from '../OfferNote';
import { OfferPriceContainer } from '../OfferPrice';
import { OfferTitleContainer } from '../OfferTitle';
import { OfferTypeContainer } from '../OfferType';
import { OfferVasContainer } from '../OfferVas';
import { Carousel } from 'shared/components/Carousel/Carousel/Carousel';
import { Address } from 'shared/components/OfferCard/Address';
import { OfferCard } from 'shared/components/OfferCard/OfferCard';
import { ShowPhone } from 'shared/components/OfferCard/ShowPhone';
import { isDailyrentOffer } from 'shared/utils/dailyrent/isDailyrent';

export const OfferCardContainer = () => {
  const [isHovered, setHovered] = React.useState(false);
  const [isAnimateHide, setAnimateHide] = React.useState(false);
  const [isHidden, setIsHidden] = React.useState(false);

  const mouseOver = React.useCallback(() => setHovered(true), []);
  const mouseOut = React.useCallback(() => setHovered(false), []);

  const { offer, position } = useOfferContext();
  const { config } = useApplicationContext();

  const { geo, phones, description, isCianPartner, externalUrl, fullUrl, id: offerId } = offer;

  const href = isCianPartner ? externalUrl : fullUrl;

  const isDailyrent = isDailyrentOffer(offer);

  const showPhoneButton = !isDailyrent;

  const handleClick = React.useCallback(() => {
    trackClickOffer(offerId ?? undefined, position);
  }, [offerId, position]);

  const handlePhoneClick = React.useCallback(() => {
    trackClickOfferPhone(offerId ?? undefined, position, href ?? undefined);
  }, [href, offerId, position]);

  const hideFromPrintClick = React.useCallback(() => {
    setAnimateHide(true);

    setTimeout(() => {
      setIsHidden(true);
    }, 500);
  }, []);

  const address = React.useMemo(() => {
    const domain = getCianDomain(config);

    return geo?.address
      ? geo.address.map((address, index, arr) => getAddress(address, index === arr.length - 1, domain))
      : [];
  }, [config, geo]);

  return (
    <OfferCard
      isHidden={isHidden}
      isAnimateHide={isAnimateHide}
      title={<OfferTitleContainer />}
      price={<OfferPriceContainer />}
      phone={showPhoneButton && <ShowPhone phones={phones ?? undefined} onClick={handlePhoneClick} />}
      agent={<OfferAgentContainer />}
      address={<Address address={address} />}
      geoInformation={<OfferGeoContainer />}
      carousel={<Carousel withControls={isHovered} />}
      area={<OfferAreaContainer />}
      type={<OfferTypeContainer />}
      controls={<ControlsContainer isHovered={isHovered} hideFromPrintClick={hideFromPrintClick} />}
      note={<OfferNoteContainer />}
      vas={<OfferVasContainer />}
      date={<PublicationDate />}
      description={description ?? undefined}
      href={href as string}
      onClick={handleClick}
      mouseOver={mouseOver}
      mouseOut={mouseOut}
    />
  );
};
